import { Constants } from '@shared/utils/constants';
import { UserSegment } from '@shared/Models';
import { jwtDecode } from 'jwt-decode';
import { isEmpty, startCase } from 'lodash-es';
import { getAppConfig } from '@shared/services/init/appConfig';
import { logger } from '@src/logger';
import { stringifyError } from '@shared/utils/errorUtils';
export const EMPTY_ACCESS_TOKEN = {
    arm: '',
    graph: '',
    spza: '',
    pifd: '',
    commerce: '',
    jarvis: '',
    marketplaceLeads: ''
};
export const isMSAUser = ({ claims })=>{
    return !isEmpty(claims) && !Object.keys(claims).includes('oid');
};
export const getUserSegment = ({ claims })=>{
    if (!claims || isEmpty(claims)) {
        return UserSegment.unauthenticated;
    }
    return isMSAUser({
        claims
    }) ? UserSegment.consumer : UserSegment.business;
};
export const createGuestUser = ()=>{
    return {
        id: '',
        group: [
            'guest'
        ],
        signedIn: false,
        tid: '',
        accessToken: EMPTY_ACCESS_TOKEN,
        oid: '',
        displayName: 'guest',
        givenName: '',
        puid: '',
        lastName: '',
        uniqueName: '',
        firstName: '',
        familyName: '',
        email: 'guest@',
        alternateEmail: '',
        isMSAUser: false,
        userSegment: UserSegment.unauthenticated,
        fieldHubUserType: Constants.FieldHubUserType.None,
        homeAccountId: null
    };
};
export const createAuthenticatedUser = ({ accessTokens, account, ssoStartTime })=>{
    try {
        var _name_split, _name_split1, _name_split2, _name_split3, _name_split4;
        const { username, homeAccountId } = account;
        const { puid, tid, name, preferred_username: preferredUsername, oid } = account.idTokenClaims;
        const { spza } = accessTokens;
        if (!spza) throw new Error('Spza token is missing');
        const userClaims = jwtDecode(spza);
        const { given_name: givenName, family_name: familyName } = userClaims;
        var _ref, _ref1, _ref2, _ref3, _ref4;
        const user = {
            id: puid,
            group: [
                'aad'
            ],
            signedIn: true,
            tid,
            displayName: startCase(name !== null && name !== void 0 ? name : username.split('@')[0]),
            givenName: startCase((_ref = givenName !== null && givenName !== void 0 ? givenName : name === null || name === void 0 ? void 0 : (_name_split = name.split(' ')) === null || _name_split === void 0 ? void 0 : _name_split[0]) !== null && _ref !== void 0 ? _ref : username.split('@')[0]),
            firstName: startCase((_ref1 = givenName !== null && givenName !== void 0 ? givenName : name === null || name === void 0 ? void 0 : (_name_split1 = name.split(' ')) === null || _name_split1 === void 0 ? void 0 : _name_split1[0]) !== null && _ref1 !== void 0 ? _ref1 : username.split('@')[0]),
            familyName: startCase((_ref2 = familyName !== null && familyName !== void 0 ? familyName : name === null || name === void 0 ? void 0 : (_name_split2 = name.split(' ')) === null || _name_split2 === void 0 ? void 0 : _name_split2[1]) !== null && _ref2 !== void 0 ? _ref2 : username.split('@')[0]),
            lastName: startCase((_ref3 = familyName !== null && familyName !== void 0 ? familyName : name === null || name === void 0 ? void 0 : (_name_split3 = name.split(' ')) === null || _name_split3 === void 0 ? void 0 : _name_split3[1]) !== null && _ref3 !== void 0 ? _ref3 : username.split('@')[0]),
            uniqueName: startCase((_ref4 = familyName !== null && familyName !== void 0 ? familyName : name === null || name === void 0 ? void 0 : (_name_split4 = name.split(' ')) === null || _name_split4 === void 0 ? void 0 : _name_split4[1]) !== null && _ref4 !== void 0 ? _ref4 : username.split('@')[0]),
            puid: puid,
            email: preferredUsername,
            oid,
            alternateEmail: preferredUsername,
            isMSAUser: isMSAUser({
                claims: userClaims
            }),
            userSegment: getUserSegment({
                claims: userClaims
            }),
            fieldHubUserType: Constants.FieldHubUserType.None,
            homeAccountId,
            accessToken: accessTokens,
            graphApi: getAppConfig('graphApi'),
            refreshToken: ''
        };
        logger.info(JSON.stringify({
            isMSAUser: user.isMSAUser,
            UserSegment: user.userSegment,
            durationInMS: ssoStartTime ? Date.now() - ssoStartTime : null
        }), {
            action: Constants.Telemetry.Action.Login,
            actionModifier: Constants.Telemetry.ActionModifier.CreateAuthenticatedUserSuccess
        });
        return user;
    } catch (error) {
        logger.error(stringifyError(error), {
            action: Constants.Telemetry.Action.Login,
            actionModifier: Constants.Telemetry.ActionModifier.CreateAuthenticatedUserFailure,
            error
        });
        return createGuestUser();
    }
};
